import React from 'react';

import Tabs from '../tabs/tabs';
import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';
import Regiona from '../regional/regionalIndex';
import Phu from '../phu/phuIndex';
import CasesTotal from '../casesTotal';
import CasesTotalTable from '../casesTotal-table';

import CasesDaily from '../casesDaily';
import CasesDailyTable from '../casesDaily-table';

import DeathsTotal from '../deathsTotal';
import DeathsTotalTable from '../deathsTotal-table';

import DeathsDaily from '../deathsDaily';
import DeathsDailyTable from '../deathsDaily-table';

import EffectiveReproduction from '../EffectiveReproduction';
import EffectiveReproductionTable from '../EffectiveReproduction-Table';

import CasesByAge from '../casesByAge';
import CasesByAgeTable from '../casesByAge-table';
import CasesByAgePie from '../CasesByAge-pie';

import Gender from '../gender/genderIndex';
import ReducedData from '../../reducedData.json';
import OnThisPage from '../onThisPage/onThisPage';
import dict from '../../dictionary';
import OverviewTable from '../overview/overviewTables';
var covidData = ReducedData.covidData;
const latest = covidData[covidData.length - 1];
const previous = covidData[covidData.length - 2];
const totalSince = 'Jan 15, 2020';

const All = (props) => {
  const stats = {
    cumm: [
      {
        label: trans.viewModes.total[props.lang],
        value: latest[dict.totaCases],
        difference: latest[dict.totaCases] - previous[dict.totaCases],
      },
      {
        label: trans.viewModes.resolved[props.lang],
        value: latest[dict.resolved],
        difference: latest[dict.resolved] - previous[dict.resolved],
      },
      {
        label: trans.viewModes.deaths[props.lang],
        value: latest[dict.deaths],
        difference: latest[dict.deaths] - previous[dict.deaths],
      },
    ],
  };
  return (
    <>
      <OverviewTable
        stats={stats}
        lang={props.lang}
        lastUpdated={props.momentBuildTime}
        totalSince={totalSince}
        withLegend={true}
        withReproduction={true}
        labels={[trans.overview.inHospital[props.lang]]}
        descs={[trans.overview.currently[props.lang]]}
      />
      <OnThisPage
        lang={props.lang}
        sections={[
          {
            href: '#case_numbers_and_spread',
            category: 'otp',
            text: 'byNumbers',
          },
          {
            href: '#age_and_gender',
            category: 'otp',
            text: 'byAgeAndGender',
          },
          {
            href: '#where_numbers',
            category: 'otp',
            text: 'numberscomefrom',
          },
        ]}
      />

      <SectionHeader
        id="case_numbers_and_spread"
        title={trans.otp.byNumbers}
        lastUpdated={props.lastUpdated}
        lang={props.lang}
      >
        <div className="ontario-row">
          <Infographic
            id=""
            lang={props.lang}
            defaultSelection="chart"
            width="full"
            titleDesc={{
              title: trans.reg.title,
            }}
            opts={['chart']}
            chart={<Regiona lang={props.lang} />}
          />

          <Infographic
            id=""
            lang={props.lang}
            defaultSelection="chart"
            width="full"
            titleDesc={trans.phu}
            desc={trans.phu.desc}
            opts={['chart']}
            chart={<Phu lang={props.lang} selectedTab="newCases" />}
          />
        </div>

        {/* <Tabs
        lang={props.lang}
        newCases={
          <Phu lang={props.lang} selectedTab="newCases" />
        }
        totalCases={
          <Phu lang={props.lang} selectedTab="totalCases" />
        }
      /> */}

        {/* 
      <FsaMap
        lang={props.lang}
        startColor={[224, 216, 193]}
        endColor={[224, 72, 7]}
      /> */}

        <div className="ontario-row ">
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <h3>{trans.casesDaily.title[props.lang]}</h3>
            <Tabs
              lang={props.lang}
              newCases={
                <Infographic
                  id="CasesDaily"
                  lang={props.lang}
                  //titleDesc={trans.casesDaily}
                  bar={
                    <CasesDaily
                      lang={props.lang}
                      chartTitle={trans.casesDaily.title[props.lang]}
                    />
                  }
                  table={<CasesDailyTable lang={props.lang} />}
                  width="default"
                />
              }
              totalCases={
                <Infographic
                  id="CasesTotal"
                  lang={props.lang}
                  // titleDesc={trans.casesTotal}
                  bar={
                    <CasesTotal
                      lang={props.lang}
                      chartTitle={trans.casesTotal.title[props.lang]}
                    />
                  }
                  table={<CasesTotalTable lang={props.lang} />}
                  width="default"
                />
              }
            />
          </div>
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <h3>{trans.deathsTotal.title[props.lang]}</h3>
            <Tabs
              lang={props.lang}
              newCases={
                <Infographic
                  id="DeathsDaily"
                  lang={props.lang}
                  //titleDesc={trans.deathsDaily}
                  bar={
                    <DeathsDaily
                      lang={props.lang}
                      chartTitle={trans.deathsDaily.title[props.lang]}
                    />
                  }
                  table={<DeathsDailyTable lang={props.lang} />}
                  width="default"
                />
              }
              totalCases={
                <Infographic
                  id="DeathsTotal"
                  lang={props.lang}
                  //titleDesc={trans.deathsTotal}
                  bar={
                    <DeathsTotal
                      lang={props.lang}
                      chartTitle={trans.deathsTotal.title[props.lang]}
                    />
                  }
                  table={<DeathsTotalTable lang={props.lang} />}
                  width="default"
                />
              }
            />
            <a href="#spikes">
              {trans.heatmap.dataAnomalies[props.lang]}
            </a>
          </div>
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <h3>
              {trans.overview.reproduction.graphTitle[props.lang]}
            </h3>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  trans.overview.reproduction.graphDesc[props.lang] +
                  ' ' +
                  trans.overview.reproduction.descB[props.lang],
              }}
            ></p>
            <Infographic
              id="Re"
              lang={props.lang}
              bar={
                <EffectiveReproduction
                  lang={props.lang}
                  chartTitle={
                    trans.overview.reproduction.graphTitle[props.lang]
                  }
                />
              }
              table={<EffectiveReproductionTable lang={props.lang} />}
              width="default"
            />
          </div>
        </div>
      </SectionHeader>
      <SectionHeader
        id="age_and_gender"
        title={trans.otp.byAgeAndGender}
        lastUpdated={props.lastUpdated}
        lang={props.lang}
      >
        <div className="ontario-row">
          <Infographic
            id="CasesByAge"
            lang={props.lang}
            titleDesc={{
              title: trans.casesByAge.title,
              desc: trans.reg.desc,
            }}
            opts={['bar', 'table', 'pie']}
            bar={
              <CasesByAge
                lang={props.lang}
                chartTitle={trans.casesByAge.title[props.lang]}
              />
            }
            table={<CasesByAgeTable lang={props.lang} />}
            pie={<CasesByAgePie lang={props.lang} />}
          />

          <Infographic
            id="Gender"
            lang={props.lang}
            titleDesc={{
              title: trans.CasesByGender.title,
              desc: trans.CasesByGender.descB,
            }}
            opts={['bar', 'table', 'pie']}
            bar={
              <Gender
                lang={props.lang}
                chartTitle={trans.CasesByGender.title[props.lang]}
              />
            }
          />
        </div>
      </SectionHeader>
    </>
  );
};

export default All;
